export default "__VITE_ASSET__80166cee__"